import styles from './popups.module.css'
import { useNavigate } from 'react-router-dom'

export const ViewProfileRedirect = ({ id, name }) => {
	const navigate = useNavigate()

	const handleViewProfile = () => {
		navigate(`/profile/${id}`)
	}

	return (
		<strong onClick={handleViewProfile} className={styles.profileRedirect}>
			{name}
		</strong>
	)
}
